// src/oura/ask/sayYes.ts
//
// Ask Oura (PREVIEW), use case 3: after a named person's yes in the Page
// workshop, the chat for that client opens on what happens next. It posts
// an answer into the client's thread and opens the panel; nothing is sent.

import type { AgreedSet } from "./agreed";
import { afterYesAnswer, type YesResult } from "./answers";
import { postNotice, setAskOpen } from "./store";
import { scopeKey } from "./types";

/** `result`: the site the yes dialog named and whether the workshop's copy worked, so the chat says the same. */
export function sayYesInChat(businessId: string, agreed: AgreedSet, actor: string, count: number, result: YesResult): void {
    // What it answers, for Ask again: after the yes, which the went-live answer covers.
    postNotice(scopeKey({ kind: "client", businessId }), "What happens after the yes?", afterYesAnswer(businessId, agreed, actor, count, new Date(), result));
    setAskOpen(true);
}
